import React from 'react';
import { CardMedia } from '@mui/material';
import hrCta from 'assets/hr_cta.png';
import CallToActionContent from './CallToActionContent';

const CallToActionHumanResources = () => (
    <CallToActionContent
        callToActionHref={
            new URL('https://www.manty.eu/contact-prospective-rh')
        }
        featureList={[
            'cta.hr.feature_1',
            'cta.hr.feature_2',
            'cta.hr.feature_3',
        ]}
        moreInfoHref={new URL('https://www.manty.eu/prospectiverh')}
        title="cta.hr.title"
        description="cta.hr.description"
        bgColor="#E9F3ED"
    >
        <CardMedia
            sx={{
                borderWidth: '0',
                maxHeight: '500px',
                aspectRatio: '1000/717', // original aspect ratio of the image
            }}
            image={hrCta}
        />
    </CallToActionContent>
);

export default CallToActionHumanResources;
